<template>
    <div class="run">
        <div class="title">
            <div class="tabType">
                <span :class="typeIdx == 0? 'se':''" @click="tabType(0)">在线监测</span>
                <span :class="typeIdx == 1? 'se':''" @click="tabType(1)">运行历史</span>
            </div>
        </div>
        <div class="content">
            <div class="runanalysis" v-if="typeIdx == 0">
                <div class="group">
                    <div class="type">组串</div>
                    <div class="name_type">
                        <div class="name">名称</div>
                        <div class="types">电压(V)</div>
                        <div class="types">电流(A)</div>
                    </div>
                    <div class="warp">
                        <div class="name_type device" v-for="(item,index) in series" :key="index">
                            <div class="name">{{item.name}}</div>
                            <div  :class="mqttval(item.U) == '--'? 'types grey':'types'">{{mqttval(item.U)}}</div>
                            <div :class="mqttval(item.I) == '--'? 'types grey':'types'">{{mqttval(item.I)}}</div>
                        </div>
                    </div>
                    
                </div>
                <div class="group">
                    <div class="type">MPPT</div>
                    <div class="name_type">
                        <div class="name">名称</div>
                        <div class="types">电压(V)</div>
                        <div class="types">电流(A)</div>
                    </div>
                    <div class="warp">
                        <div class="name_type device" v-for="(item,index) in mptts" :key="index">
                            <div class="name">{{item.name}}</div>
                            <div class="types">{{mqttval(item.U)}}</div>
                            <div class="types">{{mqttval(item.I)}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="historyChart" v-if="typeIdx == 1">
                <div class="timeSe">
                    <TimeSelect  @sendTime="sendTime"/>
                    <el-checkbox v-model="checked" @change="showEXval">最值分析</el-checkbox>
                </div>
                <div class="chartsDiargm">
                    <!-- <div :class="checked?'left':'left full' " v-if="points.length > 0"> -->
                    <div :class="checked?'left':'left full' " >
                        <Charts  id="historyDiagram" :option="options" v-if="isfull"/>
                    </div>
                    <div :class=" checked?'right':'right nofull' " >
                        <div class="itemVal" v-show="checked">
                            <div class="name">{{extreme.type}}</div>
                            <div class="extreme">
                                <p>最大值 <span :class="extreme.max == '--'?'grey':''">{{extreme.max + '' + node.unit}}</span></p>
                                <p>最小值 <span :class="extreme.min == '--'?'grey':''">{{extreme.min + '' + node.unit}}</span></p>
                                <p>平均值 <span :class="extreme.mean == '--'?'grey':''">{{extreme.mean + '' + node.unit}}</span></p>
                            </div>
                        </div>
                        
                    </div>
                    <!-- <img src="../../../assets/img/not_found_data.png" alt="" v-if="points.length == 0"> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const TimeSelect = ()=>import('./TimeSelect.vue')
const Charts  = ()=>import('../../../components/common/Charts.vue')
import {LOOP_DIAGRAM_DATA_BY_DAY, dailyInverter, getInverterMppt, getInverterSeries} from "../../../api/power";
export default { 
    props:['inverter'],
    data(){
        return {
            typeIdx:0,
            node:{},
            currentTime:'',
            xData:[],
            points:[],
            checked:true, // 是否显示极值 ,
            isfull:true, // 
            series:[],
            mptts:[],
            timer:null
        }
    },
    components:{
        TimeSelect, Charts
    },
    computed:{
        extreme(){
            let arr = this.points.sort((a,b)=>{
                return a - b
            })
            let obj = {}
            if(arr.length > 0){
                obj = {
                    min:Number(arr[0]).toFixed(2),
                    max:Number(arr[arr.length - 1]).toFixed(2),
                    mean:mean(arr),
                    type:this.node.label
                }
            }else{
                obj = {
                    min:'--',
                    max:'--',
                    mean:'--',
                    type:this.node.label
                }
            }
            

            function mean(arr){
                let sum = 0
                arr.forEach(item =>{
                    sum += Number(item)
                })
                return (sum / arr.length).toFixed(2)
            }

            return obj 
        },
        options(){
            let _this = this
            return {
                xAxis: {
                    type: 'category',
                    data: this.xData,
                    splitLine:{
                        show:true
                    },
                    axisTick:{
                        alignWithLabel:true
                    }
                },
                yAxis: [
                    {
                        type: 'value',
                        position: 'left',
                        alignTicks: true,
                        min:0,
                        max:this.points.length > 0?null:100
                    },
                ],
                title:{
					text:this.node.unit,
					left: -5,// 距离左边位置
					top: 5,// 距离上面位置
					textStyle:{
						fontWeight:'bold',
						fontSize:12,
						fontStyle:'italic'
					}
				},
                tooltip: {
                    trigger: 'axis',
                        axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function (params) {
						let str = `${params[0].name}<br/>`;
						params.forEach((item, idx) => {
							str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.value}</b><b style='font-size:14px;'> ${_this.node.unit}</b>`;
							str += idx === params.length -1? '': '<br/>'
						})
						return str
					},
                },
                legend: {
                    icon:'square',
                    top:'0px'
                },
                series: [ 
                    {
                        name: this.node.label,
                        data: this.points,
                        type: 'line',
                        markPoint: {
                            symbol:this.checked? 'pin':'none',
                            symbolSize:20,
                            data: [
                                { type: 'max', name: 'Max' },
                                { type: 'min', name: 'Min' }
                            ],
                            label:{
                                position:'top'
                            }
                        },
                    },
                ],
                grid: {
                    left: "0%",
                    right: "0%",
                    bottom: "0%",
                    top: "15%",
                    containLabel: true,
                },
            }
        },
        mqttval() {
			return this.getMqttVal(this.$store.getters.mqttVal);
		},
    },
    watch:{
        'inverter.loop_id'(val){
            // console.log(val);
            console.log(this.inverter);
            this.getMptt()
            this.getSeries()
            if(this.typeIdx == 1){
                if(this.node.value == 'Power'){
                    this.getPower(this.inverter.loop_id,this.currentTime)
                }else{
                    this.getDate(this.inverter.loop_id, this.node.value, this.currentTime)
                }
            }
            
        }
    },
    mounted(){
        let _this = this
        for(let i = 0;i<25;i++){
            this.xData[i] = `${i }点`
        }

        this.getMptt()
        this.getSeries()
        this.timer = setInterval(()=>{
			if(_this.typeIdx == 1){
                if(_this.node.value == 'Power'){
                    _this.getPower(_this.inverter.loop_id,_this.currentTime)
                }else{
                    _this.getDate(_this.inverter.loop_id, _this.node.value, _this.currentTime)
                }
            }
		}, 3600 * 1000)
    },
    destroyed(){
		if(this.timer){
			clearInterval(this.timer)
			this.timer = null
		}
        
	},
    methods:{ 
        tabType(idx){
            this.typeIdx = idx
        },
        sendTime(obj){
            console.log(obj);
            this.currentTime = obj.date
            this.node = obj.node
            // return

            if(this.node.value == 'Power'){
                this.getPower(this.inverter.loop_id,this.currentTime)
            }else{
                this.getDate(this.inverter.loop_id, this.node.value, this.currentTime)
            }
        },
        async getDate(loopid, node, time){
            let res = await LOOP_DIAGRAM_DATA_BY_DAY(loopid, node, time)
            if(res.data.code == 200){
                // console.log(node);
                if(node == 'P' || node == 'PR' || node == 'PA'){
                    let points = res.data.data.points.map(item =>item = Number(item.val / 1000).toFixed(2))
                    this.points =points
                }else{
                    let points = res.data.data.points.map(item =>item = Number(item.val).toFixed(2))
                    this.points =points
                }
                
            }else{
                // console.log(res.data.errMsg);
            }
        },
        async getPower(loopId, date){
            let res = await dailyInverter({loopId,date})
            // console.log(res);
            if(res.data.code == 200){
                this.points = res.data.data.points.map(item =>item = Number(item).toFixed(2))
            }else{
                // console.log(res.data.errMsg);
            }
        },
        showEXval(val){
            this.isfull = false
            this.$nextTick(()=>{
                this.isfull = true
            })
        },
        getMqttVal(f) {
            let currentLoop = this.inverter.loop_url.split('/').splice(1).join('/')
            return (k, m) => {
            if (currentLoop && k) {
                k = currentLoop + "/" + k;
                let mqttVal = f(k);
                mqttVal = Number(mqttVal).toFixed(2);
                if (typeof mqttVal === "object") {
                return mqttVal;
                }
                return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
            } else {
                return "--";
            }
            };
        },
        async getMptt(){
            let res = await getInverterMppt({
                inverterId:this.inverter.loop_id
            })
            console.log(res);
            if(res.data.code == 200){
                this.mptts = res.data.data.map(item =>{
                    return item = {
                        name:item.mpptName,
                        U:"U_" + item.mpptNode,
                        I:"I_" + item.mpptNode
                    }
                })
            }else{
                // console.log(res.data.errMsg);
            }
        },
        async getSeries(){
            let res = await getInverterSeries({
                inverterId:this.inverter.loop_id
            })
            console.log(res);
            if(res.data.code == 200){
                this.series = res.data.data.map((item, index) =>{
                    return item = {
                        name:item.seriesName,
                        U:"U_"+item.seriesNode,
                        I:"I_"+item.seriesNode
                    }   
                })
            }else {
                // console.log(res.data.errMsg);
            }
        },
    }
}
</script>

<style lang="less" scoped>
    .run{
        padding-top: 0vh;
        .title{
            .tabType{
                &>span{
                    height: 4vh;
                    line-height: 4vh;
                    display: inline-block;
                    padding-left: 0.7vw;
                    margin-right: 1vw;
                    font-size: 18rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #333333;
                    position: relative;
                    cursor: pointer;
                    &::before{
                        content:'';
                        width: 0.3vw;
                        height: 2vh;
                        background-color:none;
                        position: absolute;
                        top: 50%;
                        left: 0;
                        transform: translate(0, -50%);
                    }
                }
                .se{
                    color: #0D94FF;
                    &::before{
                        background-color: #0D94FF;
                    }
                }
            }

        }

        .content{
            height: 31.2vh;
            width: 100%;
            
            .runanalysis{
                width: 100%;
                height: 100%;
                box-sizing: border-box;
                border: 1px solid rgba(0, 0, 0, 0.12);
                display: flex;
                .group{
                    width: 50%;
                    height: 100%;
                    .type{
                        background: #FAFAFA;
                        border-right:1px solid rgba(0, 0, 0, 0.12) ;
                        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
                        height: 5vh;
                        box-sizing: border-box;
                        line-height: 5vh;
                        padding-left: 2vw;
                        font-size: 20rem;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        color: #333333;
                    }
                    .name_type{
                        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
                        border-right:1px solid rgba(0, 0, 0, 0.12) ;
                        height: 5vh;
                        line-height: 5vh;
                        padding-left: 2vw;
                        display: flex;
                        font-size: 18px;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        color: #666666;
                        .name{
                            width: 50%;
                            height: 100%;
                        }
                        .types{
                            width: 50%;
                            height: 100%;
                            
                        }
                    }
                    .device{
                        font-size: 18rem;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        color: #333333;
                        border-right:none;
                        height: 20%;
                        box-sizing: border-box;
                        .types{
                            width: 50%;
                            height: 100%;
                            color: #0D94FF;
                        }
                    }
                    .device:nth-child(odd){
                        background: #F5F7F9;
                    }
                    .device:last-child{
                        // border-bottom: none;
                    }
                    .warp{
                        width: 100%;
                        height: calc(100% - 10vh);
                        overflow-y: overlay;
                        overflow-x:hidden ;
                        border-right:1px solid rgba(0, 0, 0, 0.12) ;
                        
                    }
                    .warp::-webkit-scrollbar-thumb{
                        background: rgba(204,204,204, 0.3);
                    }
                }
                .group:nth-child(2){
                    .type{
                        border-right:none;
                    }
                    .name_type{
                        .name{
                            width: 33%;
                            height: 100%;
                        }
                        .types{
                            width: 33%;
                            height: 100%;
                        }
                    }
                }
                
            }
            .historyChart{
                height: 100%;
                .timeSe{
                    height: 5vh;
                    position: relative;
                    .el-checkbox{
                        position: absolute;
                        top: 1.4vh;
                        left: 74%;
                    }
                }
                .chartsDiargm{
                    height: calc(100% - 5vh);
                    display: flex;
                    justify-content: space-between;
                    position: relative;
                    &>img{
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%) scale(0.8);
                    }
                    .left{
                        width: 78%;
                        height: 100%;

                    }
                    .full{
                        width: 100%;
                    }
                    .right{
                        width: 20%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        
                        .itemVal{
                            width: 100%;
                            height: 7.5vh;
                            background: #F5F7F9;
                            display: flex;
                            padding: 0 9px;
                            justify-content: space-between;
                            align-items: center;
                            .name{
                                font-size: 14rem;
                                font-family: Source Han Sans CN;
                                font-weight: bold;
                                color: #333333;
                            }
                            .extreme{
                                &>p{
                                    font-size: 14rem;
                                    font-family: Source Han Sans CN;
                                    font-weight: 400;
                                    color: #333333;
                                    &>span{
                                        font-size: 14rem;
                                        font-weight: bold;
                                        color: #0D94FF;
                                        padding-left: 0.3vw;
                                    }
                                }
                            }
                        }
                    }
                    .nofull{
                        width: 0%;
                    }
                }
            }
        }
    }
</style>